import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeApp from './HomeMap';
import OAuthCallback from './components/dataManagement/OAtuhCallback';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeApp />} />
        <Route path="/callback" element={<OAuthCallback />} />
      </Routes>
    </Router>
  );
}

export default App;
